import Action from "../actions";

export default function productManagementReducer(state = {
    storeData: null,
    viewList: {
        productList: [],
        total: 0
    },
    addNew: {
        attribute: {
            //list: [{id: 0, name: '--'}],
            list: [],
            total: 0
        },
        category: {
            list: [{id: 0, name: '--'}],
            total: 0
        },
        countryOfManufacture: {
            list: [{id: 0, name: '--'}],
            total: 0
        },
        product: null,
        profiles: []
    },
    viewDetail: {
       
    },
    getAllProduct: {
        productList: []
    }
}, action) {
    if (action.type === Action.SET_PRODUCT_MANAGEMENT) {
        return action.data;
    }
    return state;
}
